import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import ButtonInput from '../../Helpers/Inputs/ButtonInput';
import CheckboxInput from '../../Helpers/Inputs/CheckboxInput';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import CarIcon from '../../../icons/car.svg';
import DisableIcon from '../../../icons/disabled.svg';
import WalletIcon from '../../../icons/wallet.svg';
import ChargedWithFelonyIcon from '../../../icons/chargedWithFelony.svg';
import RecklessDrivingIcon from '../../../icons/recklessDriving.svg';
import HazardousActivitiesIcon from '../../../icons/hazardousActivities.svg';


import './Background.scss';

export default function Background(props) {

  const [nextButtonLabel, setNextButtonlabel] = useState('NEXT');

  const { register, setValue } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const checkNoneOfTheAbove = (
    props.formState.TwoMovingViolations ||
    props.formState.recklessDrivingOrDUI ||
    props.formState.chargedFelony ||
    props.formState.bankruptcyWithinLast5Years ||
    props.formState.receivingSSOrDisabled ||
    props.formState.hazardousActivities
  );

  useEffect(() => {
    if (props.formState.noneApply && props.healthProfileFormState && props.healthProfileFormState.noneApply) {
      setNextButtonlabel('UPDATE QUOTE');
    } else {
      setNextButtonlabel('NEXT');
    }
  }, [props.formState.noneApply, props.healthProfileFormState.noneApply]);

  useEffect(() => {
    register({ name: 'TwoMovingViolations' });
    setValue('TwoMovingViolations', props.formState.TwoMovingViolations);

    register({ name: 'recklessDrivingOrDUI' });
    setValue('recklessDrivingOrDUI', props.formState.recklessDrivingOrDUI);

    register({ name: 'chargedFelony' });
    setValue('chargedFelony', props.formState.chargedFelony);

    register({ name: 'bankruptcyWithinLast5Years' });
    setValue('bankruptcyWithinLast5Years', props.formState.bankruptcyWithinLast5Years);

    register({ name: 'hazardousActivities' });
    setValue('hazardousActivities', props.formState.hazardousActivities);
  }, [register]);

  useEffect(() => {
    if (checkNoneOfTheAbove && props.formState.noneApply) {
      props.onFieldChange('noneApply', false);
    } else if (!checkNoneOfTheAbove && !props.formState.noneApply) {
      props.onFieldChange('noneApply', true);
    }
  }, [checkNoneOfTheAbove]);

  const buttonData = [
    {
      icon: CarIcon,
      title: '2 or more moving violations within the last 5 years',
      field: 'TwoMovingViolations',
      value: props.formState.TwoMovingViolations,
    },
    {
      icon: RecklessDrivingIcon,
      title: 'Reckless driving or DUI within the last 10 years',
      field: 'recklessDrivingOrDUI',
      value: props.formState.recklessDrivingOrDUI,
    },
    {
      icon: ChargedWithFelonyIcon,
      title: 'Charged with a felony',
      field: 'chargedFelony',
      value: props.formState.chargedFelony,
    },
    {
      icon: WalletIcon,
      title: 'Bankruptcy within the last 5 years',
      field: 'bankruptcyWithinLast5Years',
      value: props.formState.bankruptcyWithinLast5Years,
    },
    {
      icon: DisableIcon,
      title: 'Receiving social security disability or disability income',
      field: 'receivingSSOrDisabled',
      value: props.formState.receivingSSOrDisabled,
    },
    {
      icon: HazardousActivitiesIcon,
      title: 'Participate in hazardous activities',
      field: 'hazardousActivities',
      value: props.formState.hazardousActivities,
    }
  ];

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
  };

  const clearValues = () => {
    props.resetPersonalizeOptions("background");
  };
  return (
    <Container className="background-container personalize-step d-flex justify-content-center">
      <Form>
        <Row className="justify-content-center background-title">
          <h2 className="step-title">Select all that apply to you</h2>
        </Row>
        <Row className="justify-content-center">
          <p className="step-line">This will help us to find quotes and policy options to meet your unique needs.</p>
        </Row>
        <Row className={`justify-content-center ${props.isCustomizeTerm ? '' : 'mx-auto'} background pt-3`} role="group" aria-labelledby="Select Personalizing Options">
          {buttonData.map((d, index) =>
            <Col sm="auto" key={index} className="d-flex justify-content-center backgroundQuestion-div">
                <ButtonInput icon={d.icon} title={d.title} subtitle={d.subtitle} value={d.value} noMargin onClick={() => handleValueChange(d.field, !d.value)}  />
            </Col>
          )}
        </Row>
        <Row className="justify-content-center checkbox-wrapper">
          <CheckboxInput
            id="none-apply"
            onChange={clearValues}
            checked={props.formState.noneApply}
            name="none-apply"
            inputRef={register}
            label="None of these apply"
          />
        </Row>
        <Row className="pre-quote-nav-control">
          <Col xs={4} className="text-left btn-back">
            <Button variant="outlined" size="medium" color="primary" type="button" className="px-4" onClick={props.onBack}>
              BACK
            </Button>
          </Col>
          <Col xs={8} className="text-right">
            <Button variant="contained" size="medium" color="primary" type="button" className="px-4" onClick={props.onNext}>
              {nextButtonLabel.toUpperCase()}
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

Background.propTypes = {
  formState: PropTypes.object.isRequired,
  healthProfileFormState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

Background.DefaultFormState = () => {
  return {
    TwoMovingViolations: false,
    recklessDrivingOrDUI: false,
    chargedFelony: false,
    bankruptcyWithinLast5Years: false,
    receivingSSOrDisabled: false,
    hazardousActivities: false,
    noneApply: true
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Background.js